import {useEffect, useState} from 'react'
import {collection, doc, onSnapshot} from 'firebase/firestore'
import {useAuth} from 'app/modules/auth'
import db from 'services/firebase'

export const useActiveFrameworks = () => {
  const {currentUser} = useAuth()
  const [activeFrameworks, setActiveFrameworks] = useState<any[]>([])

  useEffect(() => {
    const unsubscribe = getActiveFrameworks()
    return () => unsubscribe && unsubscribe()
  }, [currentUser])

  const getActiveFrameworks = () => {
    const tenantId = currentUser?.tenantId || ''
    const tenantRef = doc(db, 'tenants', tenantId)
    const testsCollectionRef = collection(tenantRef, 'active_frameworks')

    const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
      const frameworksData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        frameworks: doc.data().frameworks,
      }))
      const frameworks = frameworksData[0]?.frameworks || []
      setActiveFrameworks(frameworks)
    })

    return unsubscribe
  }

  return {activeFrameworks}
}